import type { CardType } from '@pushflow/types'
import { Card } from '../../atoms'
import * as styles from './index.css'

export const CardsBlock = (props: { cards: string }) => {
  const cards = props.cards.split(' ') as CardType[]

  return (
    <div className={styles.cardsBlock}>
      {cards.map((card, index) => (
        <Card
          key={index}
          value={card}
        />
      ))}
    </div>
  )
}
